var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSport2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_989_21174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1602 9.04012C10.3101 7.41829 9.34778 5.85783 8.28021 4.37012C7.14088 4.92723 6.14027 5.73164 5.35138 6.72467C4.56249 7.7177 4.00522 8.87431 3.72021 10.1101C5.99855 10.2991 8.29154 10.0236 10.4602 9.30012C10.7002 9.22012 10.9302 9.13012 11.1602 9.04012Z",
    fill: "#00EC66",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.64 12.2101C12.5994 12.0911 12.5527 11.9743 12.5 11.8601C12.29 11.3601 12.06 10.8701 11.83 10.3901C11.54 10.5001 11.25 10.6201 10.94 10.7301C9.03066 11.3645 7.03196 11.6886 5.02 11.6901C4.52 11.6901 4.02 11.6601 3.52 11.6201C3.51 11.7501 3.5 11.8701 3.5 12.0001C3.50392 13.8574 4.11497 15.6624 5.24 17.1401C6.53622 15.5688 8.12574 14.2645 9.92 13.3001C10.7912 12.854 11.7018 12.4891 12.64 12.2101Z",
    fill: "#00EC66",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 3.5C11.2293 3.50399 10.4624 3.61162 9.72021 3.82C10.7588 5.29764 11.7007 6.84085 12.5402 8.44C14.2167 7.60911 15.7494 6.51528 17.0802 5.2C15.6151 4.09919 13.8328 3.50274 12.0002 3.5Z",
    fill: "#00EC66",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 18.2401C7.81177 19.6937 9.86645 20.5013 12 20.5001C13.0004 20.4991 13.9926 20.3197 14.93 19.9701C14.5312 17.8155 13.9525 15.6981 13.2 13.6401C12.306 13.8835 11.4384 14.2151 10.61 14.6301C8.92794 15.5269 7.44482 16.7549 6.25 18.2401Z",
    fill: "#00EC66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3199 19.3099C17.3805 18.6816 18.292 17.8303 18.9912 16.8151C19.6905 15.7999 20.1609 14.6449 20.3699 13.4299C18.4957 13.0251 16.5621 12.9766 14.6699 13.2869C15.3795 15.2475 15.9312 17.2615 16.3199 19.3099Z",
    fill: "#00EC66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8902 11.2702C13.9702 11.4702 14.0402 11.6702 14.1202 11.8702C16.2305 11.4787 18.3963 11.4957 20.5002 11.9202C20.4787 9.79051 19.6537 7.74751 18.1902 6.2002C16.7345 7.65916 15.0486 8.86865 13.2002 9.7802C13.4402 10.2802 13.6702 10.7702 13.8902 11.2702Z",
    fill: "#00EC66",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_989_21174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport2);
export default __webpack_public_path__ + "static/media/sport2.fcceb29f0e6530b59a8d810f6bf87952.svg";
export { ForwardRef as ReactComponent };